import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select, Row, Col} from "antd";
import {useModel} from "../../../models";

const {RangePicker} = DatePicker;

const rangeConfig = {
    rules: [{type: 'array', required: false, message: '请选择制单日期!'}],
};

export default function () {
    const [form] = Form.useForm();
    const [
        {purchaseStatusDict, invoiceTypeDict, supplierDict, purchaseOrderTypeDict},
    ] = useModel("cmDict");

    const [
        {searchParam, documentPageInfo},
        {setSearchParam, loadDocumentList, clearSearchParam}
    ] = useModel("purchasePo");


    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam]);

    useEffect(() => {
        // onReset();
        form.setFieldsValue(searchParam);
    }, []);

    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
        const {pageSize, pageNum} = documentPageInfo;
        const {purchaseCode, supplierId, orderStatus, invoiceType, orderType,purchaseDesc} = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            purchaseCode,
            supplierId,
            orderStatus,
            invoiceType,
            orderType,
            purchaseDesc
        }
        loadDocumentList({showMsg: true, data});
    }
    const onReset = () => {
        form.resetFields();
        clearSearchParam();
        loadDocumentList({showMsg: true, data: {pageSize: 15, pageNum: 1}});
    }
    return (
        <Form
            form={form}
            name="material_search"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
            labelCol={{span: "6"}}
        >
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="purchaseCode"
                        label="采购单号"
                    >
                        <Input placeholder="采购单号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="orderType"
                        label="采购类型"
                        style={{marginBottom: 0}}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择采购类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={purchaseOrderTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierId"
                        label="供应商"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择供应商"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={supplierDict}
                            dropdownClassName="dark-select"
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="orderStatus"
                        label="状态"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择状态"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={purchaseStatusDict}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="invoiceType"
                        label="发票类型"
                        style={{marginBottom: 0}}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择发票类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={invoiceTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="startEndDate"
                        label="制单日期" {...rangeConfig}
                        style={{marginBottom: 0}}
                    >
                        <RangePicker style={{width: "100%"}}/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="purchaseDesc"
                        label="备注"
                    >
                        <Input placeholder="采购备注"/>
                    </Form.Item>
                </Col>                
                <Col span={6}>
                    <Form.Item
                        shouldUpdate={true}
                        wrapperCol={{
                            offset: 6,
                            span: 24,
                        }}
                        style={{marginBottom: 0}}
                    >
                        {() => (
                            <>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    查询
                                </Button>
                                <Button
                                    htmlType="button"
                                    className="margin-left-8"
                                    onClick={onReset}
                                >
                                    重置
                                </Button>
                            </>
                        )}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}